<template>
    <div class="sport-subnav">
        <div
            v-if="isLeftSidebarExpanded || isRightSidebarExpanded"
            class="modal__overlay"
            @click="closeAllMenus"
        >
        </div>
        <button
            @click="togglePrimarySidebar"
            class="mobile-subnav__item"
        >
            <div class="mobile-subnav__item-wrapper">
                <div class="flex__align-center">
                    <FlagIcon
                        v-if="selectedItem.flag"
                        isLarge
                        :flag="`flags/${selectedItem.flag}.png`"
                    />
                    <i
                        v-if="isAll"
                        class="icon--md nav-sidebar-tree__icon icon-sport--1"
                    />
                </div>
                <span class="mobile-subnav__item-text">
                    {{ selectedItem.name | upperCase }}
                </span>
            </div>
            <template v-if="isLeftSidebarExpanded">
                <i class="icon--md icon-close"/>
            </template>
            <i v-else class="icon--md icon-filter"/>
        </button>
        <button
            class="mobile-subnav__item mobile-subnav__item--secondary"
            @click="toggleTimeFilter"
        >
            <div class="flex__align-center">
                <i class="icon--md icon-events mr-2"/>
                <span class="mobile-subnav__item-text">
                    {{ important }}
                </span>
            </div>
        </button>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { timeFilterMixing } from '@app/modules/shared/timeFilter/mixins/timeFilter';
    import { getLottoNavItem } from '@app/mobile/helpers/navigation.ts';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';
    import { ALL_LOTTERIES_NODE } from '@store/modules/ui/shared/lotto/filter/lotteryFilter.ts';

    export default {
        mixins: [timeFilterMixing],
        computed: {
            ...mapGetters('ui/lotto/filter', [
                'selectedTreeItems',
                'isSystemFilter',
                'selectedFeaturedItem',
                'featuredLottoGames',
            ]),
            ...mapGetters('ui/lotto', [
                'timeFilter',
            ]),
            ...mapGetters('ui/mobile', [
                'isSidebarOpen',
            ]),
            timeFilterId() {
                return this.timeFilter;
            },
            selectedItem() {
                return getLottoNavItem(this);
            },
            isLeftSidebarExpanded() {
                return this.isSidebarOpen(SidebarId.lottoPrimaryNav);
            },
            isRightSidebarExpanded() {
                return this.isSidebarOpen(SidebarId.lottoTimeFilterSidebar);
            },
            isAll() {
                return this.selectedItem.id === ALL_LOTTERIES_NODE.id;
            },
        },
        methods: {
            ...mapActions('ui/mobile', [
                'toggleSidebar',
                'closeSidebar'
            ]),
            closeAllMenus() {
                this.closeSidebar();
            },
            toggleTimeFilter() {
                this.toggleSidebar(SidebarId.lottoTimeFilterSidebar);
            },
            togglePrimarySidebar() {
                this.toggleSidebar(SidebarId.lottoPrimaryNav);
            },
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/mobile/lotto/LottoSubNav.vue